module.exports = __webpack_public_path__ + "img/bg-convida.82a0c47c.jpg";